import { Redirect, Switch } from 'react-router';
import PrivateRoute from '@/routes/PrivateRoute';
import CompanyCarWritePage from '@/components/pages/company/car/CompanyCarWritePage';
import CompanyCarImportPage from '@/components/pages/company/car/CompanyCarImportPage';
import CompanyCarPage from '@/components/pages/company/car/CompanyCarPage';
import CompanyCarListPage from '@/components/pages/company/car/CompanyCarListPage';
import { PATH_COMPANY, PATH_COMPANY_CAR, PATH_COMPANY_CAR_IMPORT, PATH_COMPANY_CAR_INFO, PATH_COMPANY_CAR_WRITE } from '@/constants/constant';
import CompanyRegistrationPage from '@/components/pages/company/CompanyRegistrationPage';
import CompanySignupPage from '@/components/pages/company/CompanySignupPage';
import CompanySelectPage from '@/components/pages/company/CompanySelectPage';
import CompanyUserListPage from '@/components/pages/company/CompanyUserListPage';
import CompanyUserRegistrationPage from '@/components/pages/company/CompanyUserRegistrationPage';
import SliderTemplate from '@/components/template/common/SiderTemplate';

const CompanyRoute = () => {
  return (
    <Switch>
      <PrivateRoute path="/company/signup" exact component={CompanySignupPage} />
      <PrivateRoute path="/company/select" exact component={CompanySelectPage} />
      <PrivateRoute path="/company/register" exact component={CompanyRegistrationPage} />
      <PrivateRoute b2b path="/company/user/list" exact component={CompanyUserListPage} />
      <PrivateRoute b2b path="/company/user/register" exact component={CompanyUserRegistrationPage} />
      <PrivateRoute b2b path={PATH_COMPANY_CAR_WRITE} exact component={CompanyCarWritePage} />
      <PrivateRoute b2b path={PATH_COMPANY_CAR_IMPORT} exact component={CompanyCarImportPage} />
      <PrivateRoute b2b path={PATH_COMPANY_CAR_INFO} exact component={CompanyCarPage} />
      <PrivateRoute b2b path={PATH_COMPANY_CAR} exact component={CompanyCarListPage} />
      <Redirect path={PATH_COMPANY} to="/company/user/list" />
    </Switch>
  );
};

export default CompanyRoute;
